// Player.jsx
import React, { useEffect, useState, useRef } from "react";
import { FaRegCirclePlay as PlayIcon } from "react-icons/fa6";
import { FaCirclePause as PauseIcon } from "react-icons/fa6";
/** Play Next Icon */
import { MdOutlineSkipPrevious as PreviousIcon } from "react-icons/md";
import { MdOutlineSkipNext as NextIcon } from "react-icons/md";

import { useMusic } from "../../../context/MusicContext";
import { useLocation, useNavigate } from "react-router";

import ProgressBar from "./ProgressBar";

/*** REUSABLE COMPONENTS ***/
import Loading from "../Loading/Loading";

/*** data is passed from parent, type will come (one|many) if one no need to set previous and next button ***/
const Player = ({ data, type }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isPlay, setIsPlay] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const musicContext = useMusic();

  useEffect(() => {
    if (!musicContext.musicRef) {
      musicContext.setData(data.audio_url);
    }
  }, []);



  const handlePlay = () => {
      musicContext.setMusicType(type);
      if(musicContext.dummyPlayList.length > 0) {
        musicContext.changeDummyToPlaylist();
      }

    if (musicContext.song.id !== data.id) {
      // to prevent user click play button even it's not ready to load music
      setIsLoading(true);
      musicContext.setData(data.audio_url);
      musicContext.setSong({
        title: data.title,
        artist: data.artist,
        audio_url: data.audio_url,
        id: data.id,
        image: data.image,
        route: location.pathname,
        // route: `/music/detail/songs/${data.id}`
      });
      setIsPlay(true);
      musicContext.playAudio();
      setIsLoading(false);
    } else {
      musicContext.toggleAudio();
    }
  };

  return (
    <div className="space-y-2">
      {musicContext.musicRef != null && (
        <ProgressBar
          musicData={data}
          musicRef={musicContext.musicRef}
          setIsLoading={setIsLoading}
          style={{
            marginTop: "45px",
          }}
        />
      )}
      {/* {
        musicContext.song.id === data.id ? ( */}
      <div
        className="flex justify-center bg-slate-700 py-2 rounded-full"
        style={{
          marginTop: "45px",
        }}
      >
        {type != "one" && (
          <button
            onClick={() => {
              if(musicContext.playlist && musicContext.currentIndex > 0 ) {
                musicContext.playPreviousTrack();
              }
            }}
            type="button"
            className="w-1/3 flex justify-end"
          >
            {musicContext.playlist && musicContext.currentIndex > 0 ? (
              <PreviousIcon
                className="h-12 w-12 text-yellow-300"
                aria-hidden="true"
              />
            ) : null}
          </button>
        )}

        <button
          type="button"
          className="w-1/3 rounded-full text-white flex justify-center"
        >
          {musicContext.song.id !== data.id ? (
            !isLoading ? (
              // !isPlay &&
              musicContext.song.id !== data.id ? (
                <PlayIcon
                  className="h-12 w-12 text-yellow-300"
                  aria-hidden="true"
                  onClick={handlePlay}
                />
              ) : (
                <PauseIcon
                  className="h-12 w-12 text-yellow-300"
                  aria-hidden="true"
                  onClick={musicContext.pauseAudio}
                />
              )
            ) : (
              // Loading indicator while audio is loading
              <div className="w-12 h-12">
                <Loading className="w-12 h-12" />
              </div>
            )
          ) : !musicContext.play ? (
            <PlayIcon
              className="h-12 w-12 text-yellow-300"
              aria-hidden="true"
              onClick={handlePlay}
            />
          ) : (
            <PauseIcon
              className="h-12 w-12 text-yellow-300"
              aria-hidden="true"
              onClick={musicContext.pauseAudio}
            />
          )}
        </button>
        {type != "one" && (
          <button
            onClick={() => {
              if (musicContext.playlist &&
                musicContext.currentIndex < musicContext.playlist.length - 1) {
                  musicContext.playNextTrack();
                }
            }}
            type="button"
            className="w-1/3 flex items-start"
          >
            {musicContext.playlist && musicContext.currentIndex != null &&
            musicContext.currentIndex < musicContext.playlist.length - 1 ? (
              <NextIcon
                className="h-12 w-12 text-yellow-300"
                aria-hidden="true"
              />
            ) : null}
          </button>
        )}
      </div>
    </div>
  );
};

// const MemoizedPlayer = React.memo(Player);
// export default Player;
export default Player;
